import styled from 'styled-components';

export const RadioFieldWrapper = styled.div`
  width: 100%;
  display: flex;
  padding: 0;
  height: 58px;

  .radio-div {
    width: 50%;
    font-size: 16px;
    margin-bottom: 0;
    float: left;
    flex: 1;
    color: var(--neutral-text-color);

    input[type='radio'] {
      position: absolute;
      z-index: -1;
      opacity: 0;
    }

    label {
      position: relative;
      padding: 11px 10px;
      line-height: 22px;
      cursor: pointer;
      border: 1px solid #cfd8dc;
      -webkit-transition: 0.3s;
      -o-transition: 0.3s;
      transition: 0.3s;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: rgba(0, 118, 173, 0.05);
      }
    }

    &:last-child label {
      border-left: 1px solid transparent;
    }

    input:checked + label,
    &.selected label {
      border-color: var(--input-selected-color);
      border-left: 1px solid var(--input-selected-color);
      color: var(--input-selected-text-color);
    }
  }

  &.radio-field-error .radio-div > label {
    border: 2px solid red;
  }

  @media (max-width: 767px) {
    height: 48px;
    .radio-div {
      label {
        font-size: 14px;
      }
    }
  }
`;
